import { SDKDataset } from "../model/datasets/SDKDataset";
export class ContextUtils {
    static getDatasetFromContext(context) {
        var _a, _b, _c;
        const scope = ((_a = context.scope) !== null && _a !== void 0 ? _a : {});
        return new SDKDataset({
            ...scope,
            designSystemId: (_c = (_b = scope.designSystemId) !== null && _b !== void 0 ? _b : context.designSystemId) !== null && _c !== void 0 ? _c : null,
        });
    }
    static getResolvedDatasetForContext(context, allContexts) {
        const resolveDataset = (currentContext, visitedContextIds) => {
            if (visitedContextIds.has(currentContext.id)) {
                throw new Error(`Circular context dataset inheritance detected at ${currentContext.id}`);
            }
            const nextVisitedContextIds = new Set(visitedContextIds);
            nextVisitedContextIds.add(currentContext.id);
            const dataset = this.getDatasetFromContext(currentContext);
            const parentDatasets = dataset
                .filteredContexts(allContexts)
                .map((result) => result.item)
                .filter((parentContext) => parentContext.id !== currentContext.id)
                .map((parentContext) => resolveDataset(parentContext, nextVisitedContextIds));
            const inheritedDataset = parentDatasets.reduce((unionDataset, parentDataset) => unionDataset ? unionDataset.union(parentDataset) : parentDataset, undefined);
            return inheritedDataset ? dataset.refine(inheritedDataset) : dataset;
        };
        return resolveDataset(context, new Set());
    }
    static hasCircularIncludedContextDependency({ contextsById, sourceContextId, targetContextIds, visitedContextIds = new Set(), }) {
        // Reaching a target means this source would create a cycle; revisiting any other node can be ignored.
        if (targetContextIds.has(sourceContextId) ||
            visitedContextIds.has(sourceContextId)) {
            return targetContextIds.has(sourceContextId);
        }
        visitedContextIds.add(sourceContextId);
        const sourceContext = contextsById.get(sourceContextId);
        if (!sourceContext) {
            return false;
        }
        return sourceContext.includedContextIds.some((includedContextId) => ContextUtils.hasCircularIncludedContextDependency({
            contextsById,
            sourceContextId: includedContextId,
            targetContextIds,
            visitedContextIds,
        }));
    }
}
